/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Google } from '../../assets/google.svg';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const REDIRECT_URI = `${window.location.origin}/oauth-callback`;
const SCOPE = 'profile email';
const RESPONSE_TYPE = 'code';

const getGoogleAuthUrl = () => {
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: REDIRECT_URI,
    response_type: RESPONSE_TYPE,
    scope: SCOPE,
    access_type: 'offline',
    prompt: "select_account consent",
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};

const GoogleLoginButton = () => {
  const navigate = useNavigate();
  const handleLogin = () => {
    window.location.href = getGoogleAuthUrl();
  };
  return (
    <button className="social-btn google" onClick={handleLogin}>
      <Google className="icon" /> Sign in with Google
    </button>
  );
};

export default GoogleLoginButton;
